'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defaultExport = new String('.card{border:1px solid #242628;background-color:#000;border-radius:4px;overflow:hidden;-webkit-font-smoothing:antialiased;}a{-webkit-text-decoration:none;text-decoration:none;}');

_defaultExport.__hash = '774687637';
_defaultExport.__scoped = '.card.jsx-1435942676{border:1px solid #242628;background-color:#000;border-radius:4px;overflow:hidden;-webkit-font-smoothing:antialiased;}a{-webkit-text-decoration:none;text-decoration:none;}';
_defaultExport.__scopedHash = '1435942676';
exports.default = _defaultExport;